<template lang='pug'>
  v-flex(:class="classObj", :title='label')
    v-label.uf-label {{ label }}
    div
      v-checkbox.ma-0.pr-2(v-for="item in items", v-model="data" :label="item.text", :title='item.text', :value="item.value", :key="item.value", :placeholder="component.placeholder", :required="component.required", :disabled="component.disabled", :suffix="component.suffix", :prefix="component.prefix", :multiple="component.multiple", hide-details, style="display: inline-block;", @change="onChange")
</template>

<script>
export default {
  name: 'u-checkbox',
  props: {
    id: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    value: {}
  },
  watch: {
    value (val) {
      this.data = val
    },
    data (val) {
      this.$emit('input', val)
    }
  },

  computed: {
    items () {
      let arr = []
      this.component.items.forEach((item) => {
        if (item.text) {
          arr.push({
            text: this.t(this.id + '.items.' + item.value + '.text', item.text),
            value: item.value
          })
        } else {
          arr.push(this.t(this.id + '.items.' + item + '.text', item))
        }
      })
      return [
        { header: 'Selecione ou crie uma novo item' },
        ...arr
      ]
    },
    label () {
      return this.t(this.id + '.label', this.component.label)
    }
  },

  data () {
    return {
      data: null
    }
  }
}
</script>

<style lang='stylus' scoped>
  div label
    font-size 12px
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/Checkbox.vue